import { useContext } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@mui/material";
import { ReceiptPage, AppBalanceDetailBox } from "../../../common";
import styles from "./styles.module.css";
import moment from "moment";

const QuickSalePaymentDetails = ({
  displayData,
  handleDownload,
  onRecordPayment,
  isNotShowReceipt = false,
  firstButtonTitle,
  otherCstmBtn,
  invoiceBtnTitle,
  downloadLoading,
  isCustomerTransaction,
  unpaidAmountVariant = "quickSale",
  hideReceiptActions = false,
}) => {
  const [I18n] = useContext(LanguageContext);
  const receiptFileName =
    unpaidAmountVariant === "expense"
      ? "Rupin Expense Receipt"
      : "Rupin Sale Receipt";

  return (
    <div className={styles.wrapper}>
      <div className={styles.topSection}>
        <AppBalanceDetailBox
          amount={displayData?.amount}
          status={
            displayData?.status
              ? displayData?.status
              : isCustomerTransaction
                ? displayData?.payment_mode == "Udhaar"
                  ? I18n.igave
                  : displayData?.payment_mode == "Jama"
                    ? I18n.itook
                    : ""
                : ""
          }
          unpaidAmountVariant={unpaidAmountVariant}
        />

        {isCustomerTransaction || hideReceiptActions ? null : (
          <Box className={styles.actionsRow}>
            <ReceiptPage
              invoiceId={displayData?.id ?? ""}
              isPrintIcon={false}
              isPrintBtn={false}
              invoiceStatus={displayData?.status}
              receiptDownloadId="download_recipt"
              receiptDownloadTitle={I18n.receipt}
              receiptFileName={receiptFileName}
              receiptDownloadLogEvent="invoice_receipt_download"
              onRecordPayment={onRecordPayment}
              recordPaymentId="record_pay_btn_detail_view"
              recordPaymentLogEvent="sidebar_record_payment_btn"
              onInvoiceDownload={handleDownload}
              invoiceDownloadId="invoice_download_btn"
              invoiceDownloadLogEvent="sidebar_download"
              isNotShowReceipt={isNotShowReceipt}
              firstButtonTitle={firstButtonTitle}
              otherCstmBtn={otherCstmBtn}
              invoiceBtnTitle={invoiceBtnTitle}
              downloadLoading={downloadLoading}
            />
          </Box>
        )}
      </div>

      {displayData?.status?.toLowerCase() == "paid" ? (
        <ParagraphText
          className={`fontSize14 fontWeight400 foundationGreenColor ${styles.paidOnText}`}
          // auto: an Urdu label makes the line read right to left, English stays left to right
          dir="auto"
        >
          {I18n.paid_on}{" "}
          {displayData?.transacted_at
            ? moment(displayData.transacted_at).format("D MMM YYYY")
            : ""}
        </ParagraphText>
      ) : null}
    </div>
  );
};

export default QuickSalePaymentDetails;
